import FormattedOutput from './FormattedOutput';
export default FormattedOutput;